import React from 'react';
import { Link } from 'react-router-dom';

const FooterComponent = () => {
  return (
    <footer className="bg-[#00318e] text-white py-8 mt-auto">
      <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 md:grid-cols-3 gap-8">
        <div className="flex flex-col items-start">
            <div className='flex flex-col justify-center items-left'>
                <img src="/logo.png" alt="IPSA Logo" className="w-20 h-auto mb-2" />
                <p className="text-sm italic">"We Are There For You"</p>
            </div>        
          <h3 className="text-lg font-semibold mb-2 mt-4">Social Media Links</h3>
            <ul className="space-y-2 text-sm">
                <li className="flex items-center space-x-2">
                    <svg className="h-5 w-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M4.98 3.5C4.98 4.88 3.88 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1 4.98 2.12 4.98 3.5zM0 8h5v16H0V8zm7.5 0h4.7v2.2h.1c.7-1.3 2.4-2.7 5-2.7 5.3 0 6.3 3.5 6.3 8v8.5h-5V17c0-2.4-.1-5.5-3.3-5.5-3.3 0-3.8 2.6-3.8 5.3v7.2h-5V8z" />
                    </svg>
                    <a
                      href="https://www.linkedin.com/company/institute-for-patient-safety-africa/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:underline text-white"
                    >
                      LinkedIn
                    </a>                
                </li>
                <li className="flex items-center space-x-2">
                    <svg className="h-5 w-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M22.675 0H1.325C.593 0 0 .593 0 1.325v21.351C0 23.407.593 24 1.325 24h11.495v-9.294H9.691v-3.622h3.129V8.413c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.464.099 2.795.143v3.24l-1.918.001c-1.504 0-1.796.715-1.796 1.763v2.313h3.587l-.467 3.622h-3.12V24h6.116C23.407 24 24 23.407 24 22.675V1.325C24 .593 23.407 0 22.675 0z" />
                    </svg>
                    <Link to="/about" className="hover:underline text-white">Facebook</Link>
                </li>
                <li className="flex items-center space-x-2">
                    <svg className="h-5 w-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M23.954 4.569c-.885.392-1.83.656-2.825.775 1.014-.611 1.794-1.574 2.163-2.723-.949.555-2.005.959-3.127 1.184-.897-.959-2.178-1.555-3.594-1.555-2.717 0-4.92 2.203-4.92 4.917 0 .39.045.765.127 1.124C7.691 8.094 4.066 6.13 1.64 3.161c-.427.722-.666 1.561-.666 2.475 0 1.708.87 3.213 2.188 4.096-.807-.026-1.566-.248-2.229-.616v.061c0 2.385 1.693 4.374 3.946 4.827-.413.111-.849.171-1.296.171-.314 0-.615-.03-.916-.086.631 1.953 2.445 3.377 4.6 3.419-1.68 1.319-3.809 2.105-6.102 2.105-.39 0-.779-.023-1.17-.067 2.189 1.394 4.768 2.209 7.557 2.209 9.054 0 14-7.496 14-13.986 0-.21 0-.423-.015-.634.961-.689 1.8-1.56 2.46-2.548l-.047-.02z" />
                    </svg>
                    <Link to="/policies/free" className="hover:underline text-white">X / Twitter</Link>
                </li>
                <li className="flex items-center space-x-2">
                    <svg className="h-5 w-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M19.615 3.184C20.403 3.184 21 3.781 21 4.569v14.862c0 .788-.597 1.385-1.385 1.385H4.385C3.597 20.816 3 20.219 3 19.431V4.569c0-.788.597-1.385 1.385-1.385h15.23zM10 15.5l6-3.5-6-3.5v7z" />
                    </svg>
                    <Link to="/systems/overview" className="hover:underline text-white">YouTube</Link>
                </li>
            </ul>
        </div>
        
        <div>
          <h3 className="text-lg font-semibold mb-2">Quick Links</h3>
          <ul className="space-y-1 text-sm">
            <li><Link to="/" className="hover:underline">Home</Link></li>
            <li><Link to="/about-us" className="hover:underline">About IPSA</Link></li>
            <li><Link to="/policies/free" className="hover:underline">Free Policies</Link></li>
            <li><Link to="/systems/overview" className="hover:underline">Systems</Link></li>
            <li><Link to="/consultancy" className="hover:underline">Consultancy</Link></li>
            <li><Link to="/contact-us" className="hover:underline">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="text-lg font-semibold mb-2">Contact Us</h3>
          <p className="text-sm">Institute for Patient Safety Africa</p>
          <p className="text-sm">Email: info@ipsa.africa</p>
          <p className="text-sm">Phone: +254 712 345 678</p>
          <p className="text-sm">Location: Kenya</p>
        </div>
      </div>

      <div className="mt-8 border-t border-white/20 pt-4 text-center text-xs text-white/80">
        &copy; {new Date().getFullYear()} Institute for Patient Safety Africa. All rights reserved.
      </div>
    </footer>
  );
};

export default FooterComponent;
